import { activeLuckets, activeLucketsWeek, weekLuckets } from "./filterBuckets";

export function countActivePointsBuckets(luckets,currentDate){
      
    let count = 0;
    let activeBuckets = activeLuckets(luckets, currentDate);
    activeBuckets.forEach((element,i,a) => {
        count += Number(element.points)
    });
     
    return count
}
export function countDoneBuckets(luckets,currentDate){
      
    let count = 0;
    let activeBuckets = activeLuckets(luckets, currentDate);

    activeBuckets.forEach((element,i,a) => {
        if(element.actionStatus == "blue"){
            count += Number(element.points)
        } 
    });
      
    return count
}

export function countDoneWeekBucketsForBucket(luckets,currentDate,lucket){
    let lucketsOfSameName = luckets.filter((l)=>l.name === lucket.name)
    let doneWeekBucketsForBucket = countDoneLucketsPastWeek(lucketsOfSameName, currentDate);
    //count child points
    let childLuckets = luckets.filter(l=>(l.parentRowID == lucket.rowID)&&l.parentRowID !== "")
    let childsCount = childLuckets.reduce((ac,v,i)=>{
        let childLucketsOfSameName = luckets.filter((l)=>l.name === v.name)
        let childCount = countDoneLucketsPastWeek(childLucketsOfSameName,currentDate)
        return ac + childCount
    },0)
    return childsCount + doneWeekBucketsForBucket
}


export function countActivePointsBucketsWeek(luckets,currentDate){
    let count = 0;
    let activeBuckets = activeLucketsWeek(luckets, currentDate);
    activeBuckets.forEach((element,i,a) => {
        count += Number(element.weekPoints)
    });
     
    return count
}
export function countDoneBucketsWeek(luckets,currentDate){
    let count = 0;
    let activeBuckets = activeLucketsWeek(luckets, currentDate);
     
    activeBuckets.forEach((element,i,a) => {
        if(element.weekActionStatus == "blue"){
            count += Number(element.weekPoints)
        } 
    });
      
    return count
}



export function countDoneLucketsPastWeek(luckets,currentDate){
    if(!luckets)return[]
    let datesSinceLastSunday = getDatesSinceLastSunday(currentDate)
    let count = datesSinceLastSunday.reduce((acc,v)=>{
        let countDoneBucketsDay = countDoneBuckets(luckets,v)
        acc = acc + countDoneBucketsDay
        return acc
    },0)
    return count
}
function getDatesSinceLastSunday(currentDate) {
    const today = new Date(currentDate);
    const dayOfWeek = today.getDay(); // 0 is Sunday, 1 is Monday, ..., 6 is Saturday
  
    const daysSinceSunday = (dayOfWeek + 6) % 7; // Calculate days since last Sunday
  
    const lastSunday = new Date(today.getTime() - daysSinceSunday * 24 * 60 * 60 * 1000); // Calculate date of last Sunday
  
    const dateList = [];
    for (let i = lastSunday; i <= today; i.setDate(i.getDate() + 1)) {
      dateList.push(new Date(i).toLocaleDateString());
    }
  
    return dateList;
  }
